import {
  extractData,
  extractDataWithMeta,
} from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  WebCamsDtoSchema,
  WebCamsPageDtoSchema,
  WebCamTypesDtoSchema,
} from "./schemas";
import type { WebCamsPageType, WebCamsType, WebCamTypesType } from "./types";

const defaultMeta = {
  pagination: { page: 1, pageSize: 0, pageCount: 0, total: 0 },
};

export const mapDtoToWebCamsPage = (dto: unknown): WebCamsPageType => {
  const parsed = safeParseWithFallback(
    WebCamsPageDtoSchema,
    dto,
    "mapDtoToWebCamsPage",
  );

  return extractData(parsed, dto, dto as WebCamsPageType);
};

export const mapDtoToWebCams = (dto: unknown): WebCamsType => {
  const parsed = safeParseWithFallback(
    WebCamsDtoSchema,
    dto,
    "mapDtoToWebCams",
  );

  return extractDataWithMeta<WebCamsType["data"], WebCamsType["meta"]>(
    parsed,
    dto,
    defaultMeta as WebCamsType["meta"],
  );
};

export const mapDtoToWebCamTypes = (dto: unknown): WebCamTypesType[] => {
  const parsed = safeParseWithFallback(
    WebCamTypesDtoSchema,
    dto,
    "mapDtoToWebCamTypes",
  );

  return extractData(parsed, dto, []);
};
